import { render, staticRenderFns } from "./ReadingTable.vue?vue&type=template&id=01d8e1fc&scoped=true&"
import script from "./ReadingTable.vue?vue&type=script&lang=ts&"
export * from "./ReadingTable.vue?vue&type=script&lang=ts&"
import style0 from "./ReadingTable.vue?vue&type=style&index=0&id=01d8e1fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d8e1fc",
  null
  
)

export default component.exports